export default __webpack_public_path__ + "src/images/sections/c489e81a2344a49a17e0a9b0fb4cc9f7-pack-bags.jpg";